import styled from '@emotion/styled'
import { TruncateText } from '@liveHelper/components/shared/styles'
import { FadeInAnimation, FlexCenter } from '@oneToOne/shared/styles'

export const AvatarContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background: var(--gray-10);
  ${FlexCenter}
  ${FadeInAnimation}
`

export const AvatarCircle = styled.div`
  position: absolute;
  overflow: hidden;
  ${FlexCenter}
  width: 64px;
  height: 64px;
  border-radius: 50%;
  padding: var(--spacing-8);
  background: var(--gray-8);
  color: var(--white);
`

export const AvatarName = styled.span`
  ${TruncateText}
`
